import { COLORS } from '../theme';

export default {
  styleOverrides: {
    root: {
      width: 32,
      height: 20,
      padding: 0,
      marginRight: 7,

      '&.MuiSwitch-sizeSmall': {
        width: 24,
        height: 16,
      },
    },
    switchBase: {
      padding: 0,
      margin: 4,

      '&.Mui-checked': {
        transform: 'translateX(12px)',
      },

      '.MuiSwitch-sizeSmall &&': {
        margin: 0,

        '&.Mui-checked': {
          transform: 'translateX(8px)',
        },
      },
    },
    thumb: {
      width: 12,
      height: 12,
      color: COLORS.white,
      boxShadow: 'none',

      '.MuiSwitch-sizeSmall &&': {
        width: 8,
        height: 8,
      },

      '.Mui-focusVisible &': {
        boxShadow: `0 0 0 2px ${COLORS.blackTransparent}`,
      },
    },
    track: {
      borderRadius: 20,
      background: COLORS.black30,
      opacity: 1,

      '.Mui-checked + &&': {
        backgroundColor: COLORS.green,
        opacity: 1,
      },

      '.Mui-disabled + &&': {
        opacity: 1,
        background: COLORS.black10,
      },

      '.Mui-checked.Mui-disabled + &': {
        opacity: 0.5,
        background: COLORS.green,
      },
    },
  },
};
